import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '../../../layout/Avatar.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { SessionDurationBadge } from '../../notifications/SessionDurationBadge.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD } from '../../../shared/format.js';
import { useDuration } from '../../../shared/useDuration.js';
import { LiveBillBadge } from './LiveBillBadge.jsx';
import { ChildEditModal } from './ChildEditModal.jsx';

function resolvePhoto(url) {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('/api/') || url.startsWith('/uploads/')) return url;
  return `/api/children/photos/${url.replace(/^\//, '')}`;
}

export function ActiveRow({ session }) {
  const [editOpen, setEditOpen] = useState(false);
  // Backend populates `childId` / `guardianId` with full objects.
  const child = session.childId || session.child || {};
  const guardian = session.guardianId || session.guardian || {};
  const duration = useDuration(session.startTime, 1000);
  const photoUrl = resolvePhoto(child.photoUrl);
  // الخادم صار يحسب التجاوز من مدة الباقة (status لا يحمل expired/overstay أبداً)
  const isOverstay = !!session.overDuration;
  const hasPending = (session.pendingAmount || 0) > 0 || session.hasPendingInvoices;

  return (
    <tr className="border-b border-line">
      <td className="p-2.5">
        <div className="flex items-center gap-2">
          <Avatar src={photoUrl} name={child.name || '?'} id={child._id || child.id} size="sm" />
          <div>
            <div className="font-bold text-[13px]">{child.name || '—'}</div>
            <div className="text-[11px] text-ink-3">{child.age || '?'} سنوات</div>
          </div>
        </div>
      </td>
      <td className="p-2.5">
        {guardian.name || '—'}
        <div className="text-[11px] text-ink-3" dir="ltr">{guardian.phone || ''}</div>
      </td>
      <td className="p-2.5">
        <div className="font-mono font-bold" dir="ltr">
          {session.cardUid || session.cardId?.uid || session.card?.uid || '—'}
        </div>
        <div className="flex gap-1 mt-0.5">
          {Number(session.groupSize) > 1 ? (
            <Pill variant="muted" className="!px-1.5 !py-0 !text-[10px]">مشترك ×{session.groupSize}</Pill>
          ) : null}
          {Number(session.companionsCount) > 0 ? (
            <Pill variant="muted" className="!px-1.5 !py-0 !text-[10px]">+{session.companionsCount} مرافق</Pill>
          ) : null}
          {session.subscriptionCovered ? (
            <Pill variant="info" className="!px-1.5 !py-0 !text-[10px]">اشتراك شهري</Pill>
          ) : null}
          {session.entrySource === 'gate' ? (
            <Pill variant="muted" className="!px-1.5 !py-0 !text-[10px]">دخول بالبوابة</Pill>
          ) : null}
        </div>
      </td>
      <td className="p-2.5 font-mono" style={{ color: isOverstay ? '#B91C1C' : '#1A1A1A' }}>
        {duration.formatted}
        <div className="mt-0.5"><SessionDurationBadge session={session} /></div>
      </td>
      <td className="p-2.5">
        {session.pricingType === 'hourly' ? 'ساعي' :
          session.pricingType === 'package' ? 'باقة' :
          session.pricingType === 'open' ? 'مفتوح' : 'ثابت'}
      </td>
      <td className="p-2.5">
        <LiveBillBadge session={session} />
      </td>
      <td className="p-2.5">
        {hasPending ? <b className="text-red">{formatIQD(session.pendingAmount || 0)}</b> : '—'}
      </td>
      <td className="p-2.5">
        {isOverstay ? <Pill variant="danger">تجاوز المدة</Pill> : <Pill variant="success">فعّال</Pill>}
      </td>
      <td className="p-2.5">
        <div className="flex items-center gap-1.5 justify-end">
          <button
            type="button"
            className="btn"
            style={{ padding: '4px 8px', fontSize: 12 }}
            onClick={() => setEditOpen(true)}
            title="تعديل معلومات الطفل"
          >
            <Icon name="edit" size={13} />
          </button>
          <Link to={`/checkout/${session._id || session.id}`} className="btn btn-primary" style={{ padding: '4px 10px', fontSize: 12 }}>
            تسوية
          </Link>
        </div>
        <ChildEditModal open={editOpen} session={session} onClose={() => setEditOpen(false)} />
      </td>
    </tr>
  );
}
